(function(){
  if(window.__sqCollectionHierarchyGuardV8)return;
  window.__sqCollectionHierarchyGuardV8=true;

  function boot(){
    if(/^\/collections\/state-guard-series(?:-|\/|$)/i.test(location.pathname))return;
    var main=document.getElementById('MainContent');
    var rail=document.querySelector('[data-sq-collection-rail]');
    if(!main||!rail)return;

    var groupMeta={
      categories:{item:'[data-sq-context-categories]',list:'[data-sq-context-categories-list]'},
      subcategories:{item:'[data-sq-context-subcategories]',list:'[data-sq-context-subcategories-list]'},
      types:{item:'[data-sq-context-types]',list:'[data-sq-context-types-list]'},
      organizations:{item:'[data-sq-context-organizations]',list:'[data-sq-context-organizations-list]'}
    };

    function serviceBflRoot(){
      return /^\/collections\/(?:products-built-for-the-line-u-s-army|army-national-guard-series|products-built-for-the-line-u-s-air-force|air-national-guard-series|products-built-for-the-line-u-s-navy|products-built-for-the-line-u-s-marine-corps|products-built-for-the-line-u-s-coast-guard|products-built-for-the-line-u-s-space-force)\/?$/i.test(location.pathname);
    }

    function urlOf(raw){
      try{
        var url=new URL(raw,window.location.origin);
        if(url.origin!==window.location.origin)return null;
        return url;
      }catch(error){return null;}
    }

    function normalize(raw){
      var url=urlOf(raw);if(!url)return'';
      url.searchParams.delete('preview_theme_id');
      url.searchParams.delete('filter.v.availability');
      url.hash='';
      return url.pathname+'?'+url.searchParams.toString();
    }

    function exposeDynamicNavCards(){
      Array.prototype.forEach.call(main.querySelectorAll('.sqsg-orgs a[href]'),function(a){
        var u=urlOf(a.href);
        if(u&&u.searchParams.has('sg_org')&&a.getAttribute('data-sq-nav-card')!=='true')a.setAttribute('data-sq-nav-card','true');
      });
    }

    function desiredGroup(a,bookTypeKeys){
      var u=urlOf(a.href);if(!u)return'';
      var p=u.searchParams;
      if(p.has('sg_org')&&!p.has('sg_category'))return'organizations';
      if(p.has('sg_category')){
        if(p.has('sg_component')||p.has('sg_accessory_type'))return'types';
        if(p.has('sg_type'))return p.get('sg_category')==='uniforms'?'subcategories':'types';
        return'categories';
      }
      if(bookTypeKeys[normalize(a.href)])return'types';
      return'';
    }

    function fixTaxonomyGroups(){
      var bookTypeKeys={};
      Array.prototype.forEach.call(main.querySelectorAll('.sq-books-tree[data-mode="type"] .sq-books-tree__card[href]'),function(a){
        var key=normalize(a.href);if(key)bookTypeKeys[key]=true;
      });
      var all=[];
      Object.keys(groupMeta).forEach(function(name){
        var list=rail.querySelector(groupMeta[name].list);if(!list)return;
        Array.prototype.forEach.call(list.querySelectorAll('a[href]'),function(a){all.push(a);});
      });
      all.forEach(function(a){
        var targetName=desiredGroup(a,bookTypeKeys);if(!targetName)return;
        var target=rail.querySelector(groupMeta[targetName].list);if(!target)return;
        var li=a.closest('li');if(!li||li.parentElement===target)return;
        var key=normalize(a.href),duplicate=null;
        Array.prototype.forEach.call(target.querySelectorAll('a[href]'),function(existing){
          if(!duplicate&&normalize(existing.href)===key)duplicate=existing;
        });
        if(duplicate){li.remove();return;}
        target.appendChild(li);
      });
      Object.keys(groupMeta).forEach(function(name){
        var item=rail.querySelector(groupMeta[name].item),list=rail.querySelector(groupMeta[name].list);
        if(item&&list){var shouldHide=list.children.length===0;if(item.hidden!==shouldHide)item.hidden=shouldHide;}
      });
    }

    function customProductSurfaceActive(){
      if(serviceBflRoot()&&main.querySelector('[data-sqbfl-root],.sqbfl'))return true;
      if(main.classList.contains('sq-refine-restored-filtering'))return true;
      if(document.documentElement.classList.contains('sqsg-on')||main.querySelector('[data-sqsg]'))return true;
      if(main.querySelector('.sq-green-service-builder'))return true;
      return false;
    }

    function ensureProducts(){
      document.documentElement.classList.remove('sq-hierarchy-choice-stage');
      if(customProductSurfaceActive())return;
      Array.prototype.forEach.call(main.querySelectorAll('collection-component'),function(node){
        if(node.hidden)node.hidden=false;
        if(node.hasAttribute('aria-hidden'))node.removeAttribute('aria-hidden');
        if(node.style.getPropertyValue('display')!=='block'||node.style.getPropertyPriority('display')!=='important')node.style.setProperty('display','block','important');
        var wrapper=node.closest('[id^="shopify-section-template--"],.shopify-section');
        if(wrapper){
          if(wrapper.hidden)wrapper.hidden=false;
          if(wrapper.hasAttribute('aria-hidden'))wrapper.removeAttribute('aria-hidden');
          if(wrapper.style.getPropertyValue('display')!=='block'||wrapper.style.getPropertyPriority('display')!=='important')wrapper.style.setProperty('display','block','important');
          if(wrapper.style.getPropertyValue('visibility'))wrapper.style.removeProperty('visibility');
          if(wrapper.style.getPropertyValue('opacity'))wrapper.style.removeProperty('opacity');
        }
      });
    }

    function productOnlyBody(){
      if(customProductSurfaceActive())return;
      var selectors=[
        '.sq-shop-all-directory',
        '.sq-subcategory-section',
        '.sq-third-level',
        '.sq-ts-match-section',
        '.sq-books-tree',
        '.sq-ptype-browser',
        '[data-sq-afg-mode]',
        '.vac-guard-folders',
        '.sq-line-series-categories',
        '.sq-line-program-tree',
        '.sq-ps-root',
        '.vac-category-grid',
        '.vac-series-grid',
        '.vac-military-folders',
        '.vac-uniform-insignia-button',
        '.vac-armor-browser',
        '.vac-gift-categories',
        '.vac-knives-browser',
        '[data-sq-mirrored-to-rail="true"]'
      ];
      Array.prototype.forEach.call(main.querySelectorAll(selectors.join(',')),function(section){
        if(section.closest('collection-component,.product-grid-container'))return;
        section.hidden=true;
        section.setAttribute('aria-hidden','true');
        section.style.setProperty('display','none','important');
        section.setAttribute('data-sq-body-navigation-hidden','true');
      });
    }

    function apply(){
      exposeDynamicNavCards();
      fixTaxonomyGroups();
      productOnlyBody();
      ensureProducts();
    }

    var timer=0;
    function schedule(){clearTimeout(timer);timer=setTimeout(apply,90);}
    apply();
    [250,900,2200,5000,7500].forEach(function(ms){setTimeout(apply,ms);});
    new MutationObserver(schedule).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','href','hidden','data-sq-nav-card','data-sq-mirrored-to-rail','aria-hidden']});
    new MutationObserver(schedule).observe(rail,{childList:true,subtree:true});
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
